import { useNavigate } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'
import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { refreshAccessToken } from '../../../utilities/extensions'

export default function DashboardDocumentsHeader() {
  const navigate = useNavigate()
  const [canDownloadUF, setCanDownloadUF] = useState(true)
  const [downloadingPDF, setDownloadingPDF] = useState(false)

  useEffect(() => {
    const handleDownloadUF = async () => {
      try {
        const newUrlResponse = await fetch(`${apiURL}/api/generateS3URL?url=${encodeURIComponent(customerData.customerDocuments.taxDocument2021UF)}`, {
          headers: {
            'Authorization': customerData.accessToken
          }
        })
        const newUrlData = await newUrlResponse.json()
        if (newUrlData.response.error) {
          if (newUrlData.response.error === 'Failed To Authenticate Token.') {
            const refreshedToken = await refreshAccessToken()
            refreshedToken && refreshedToken.length > 0 ? await handleDownloadUF() : navigate('/', { state: { expired: true } })
          } else
            console.error(newUrlData.response.error)
        } else {
          const downloadResponse = await fetch(newUrlData.response.s3Url)
          if (!downloadResponse.ok)
            setCanDownloadUF(false)
        }
      } catch (error) {
        //setCanDownloadUF(false)
      }
    }

    if (customerData.customerDocuments.taxDocument2021UF)
      handleDownloadUF()
    else
      setCanDownloadUF(false)
  }, [])

  const handleDownloadPDF = async (pdfURL) => {
    setDownloadingPDF(true)

    const addForm8888Response = await fetch(`${apiURL}/api/addForms?customerId=${customerData.customerLeadData.leadContact.contactId}&linkURL=${pdfURL}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const blob = await addForm8888Response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url;
    a.download = customerData.customerDocuments.taxDocument2021.split('/').pop()
    document.body.appendChild(a)
    a.click()
    a.remove()

    setDownloadingPDF(false)
  }

  return (
    <div className='lg:w-full w-11/12 flex flex-col items-center justify-center bg-white rounded-md shadow-full gap-4 font-robo p-4'>
      <p className='font-bold text-xl'>Refund Documents Available</p>
      {customerData.customerDocuments.taxDocument2020.length > 0 && (
        <>
          <p>Download your 2020 IRS Forms to be Completed, Signed, and Mailed</p>
          <button onClick={() => handleDownloadPDF(customerData.customerDocuments['taxDocument2021'])} className='w-full bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white p-4 rounded-md shadow-full'>Download 2020 Tax Documents</button>
        </>
      )}
      {customerData.customerDocuments.taxDocument2021.length > 0 && (
        <>
          {customerData.customerLeadData.leadStage.leadStageId === '04144458-31da-4f86-be7b-69051d6c1cc9' ? (
            <p>Download your 2021 IRS Forms, to be completed, signed, and shipped. Please enjoy the video above for detailed instructions.</p>
          ) : (
            <p>Download your 2021 IRS Forms to be Completed, Signed, and Mailed</p>
          )}
          <button disabled={downloadingPDF} onClick={() => canDownloadUF ? navigate('/downloadDocument') : handleDownloadPDF(customerData.customerDocuments['taxDocument2021'])} className={`${downloadingPDF ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'} w-full text-white p-4 rounded-md shadow-full`}>Download 2021 Tax Documents</button>
        </>
      )}
      {downloadingPDF && (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8 mt-4 mb-4'></div>
          <p>Downloading PDF...</p>
        </div>
      )}
    </div>
  )
}